import axios from "axios";
import { config } from "../../../config/Config";

export const getSystemDefaultData = async (obj) => {
    try {
        const response = await axios({
            method: 'get',
            url: `${config.serverBaseUrl}/v1/web/geo-data-store/${obj.type}`,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching countries:', error.response?.data || error.message);
        throw error;
    }
};

export const getAllCountries = async () => {
    try {
        const response = await axios({
            method: 'get',
            url: `${config.serverBaseUrl}/v1/web/geo-data-store/countries`,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching currencies:', error.response?.data || error.message);
        throw error;
    }
};

export const getAllCurrencies = async () => {
    try {
        const response = await axios({
            method: 'get',
            url: `${config.serverBaseUrl}/v1/web/geo-data-store/currencies`,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching currencies:', error.response?.data || error.message);
        throw error;
    }
};

export const getAllLanguages = async () => {
    try {
        const response = await axios({
            method: 'get',
            url: `${config.serverBaseUrl}/v1/web/geo-data-store/languages`,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching languages:', error.response?.data || error.message);
        throw error;
    }
};

export const getAllRegions = async () => {
    try {
        const response = await axios({
            method: 'get',
            url: `${config.serverBaseUrl}/v1/web/geo-data-store/regions`,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching regions:', error.response?.data || error.message);
        throw error;
    }
};

export const getAllTimezones = async () => {
    try {
        const response = await axios({
            method: 'get',
            url: `${config.serverBaseUrl}/v1/web/geo-data-store/timezones`,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching timezones:', error.response?.data || error.message);
        throw error;
    }
};